import { ProductResource, ResourceNameTypeEnum } from '@bondsports/types';
import { Membership } from '../../../../../types/membership';
import { BasicResource, ResourceObj } from '../../../../../types/resources';

export const createSelectedResourcesObject = (
	quantity: number,
	resourceType: ResourceNameTypeEnum,
	resources: (Membership | ResourceObj | BasicResource | ProductResource)[]
) => {
	return {
		selectedResources: {
			quantity: quantity,
			resourceType: resourceType,
			resources: resources ?? [],
		},
	};
};

export const createSelectAllInfo = (
	quantity: number,
	resourceType: ResourceNameTypeEnum,
) => {
	return {
		selectedResources: {
		quantity: quantity,
		resourceType,
		isAll: true,
		resources: []
		}
	};
}
